<template>
  <KemudahanAsasBase :amenity="amenity" />
</template>

<script>
// Bekalan Air — Peratusan isi rumah mengikut jenis bekalan air. Sub-kategori:
// Air paip dirawat / Air paip awam / Lain-lain (rujuk Lampiran 2). All UI, filters
// and export live in KemudahanAsasBase; this page only supplies the config.
import KemudahanAsasBase from "./KemudahanAsasBase.vue";

export default {
  name: "BekalanAir",
  components: { KemudahanAsasBase },
  data() {
    return {
      amenity: {
        key: "air",
        endpoint: "getBekalanAirLampiran",
        icon: "mdi-water-pump",
        title: "Bekalan Air",
        subtitle: "Peratusan isi rumah mengikut jenis bekalan air, strata dan daerah pentadbiran",
        cardTitle: "Peratusan Isi Rumah mengikut Bekalan Air",
        exportTitle: "PERATUSAN ISI RUMAH MENGIKUT BEKALAN AIR",
        subCategories: ["Air paip dirawat", "Air paip awam", "Lain-lain"],
        sheetName: "Bekalan Air",
        fileSlug: "Peratusan_Isi_Rumah_Bekalan_Air",
      },
    };
  },
};
</script>
